import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  userDetails: null,
  companyDetails: null,
  updatingUser: false,
  loadCompanyPickupAddress: false,
  loadCompanyBillingAddress: false,
  companyPickupAddress: null,
  companyBillingAddress: null,
};

const userEditSlice = createSlice({
  name: "userEdit",
  initialState,
  reducers: {
    fetchUserDetails(state, action) {
      state.loading = true;
      state.userDetails = null;
    },
    fetchUserDetailsSuccess(state, action) {
      state.userDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchUserDetailsFailure(state, action) {
      state.loading = false;
    },
    fetchCompanyDetails(state, action) {
      state.loading = true;
    },
    fetchCompanyDetailsSuccess(state, action) {
      state.companyDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyDetailsFailure(state, action) {
      state.loading = false;
    },
    fetchCompanyPickupAddress(state, action) {
      state.loadCompanyPickupAddress = true;
    },
    fetchCompanyPickupAddressSuccess(state, action) {
      state.loadCompanyPickupAddress = false;
      state.companyPickupAddress = action.payload.data.document;
    },
    fetchCompanyPickupAddressFailure(state, action) {
      state.loadCompanyPickupAddress = false;
    },
    fetchCompanyBillingAddress(state, action) {
      state.loadCompanyBillingAddress = true;
    },
    fetchCompanyBillingAddressSuccess(state, action) {
      state.loadCompanyBillingAddress = false;
      state.companyBillingAddress = action.payload.data.document;
    },
    fetchCompanyBillingAddressFailure(state, action) {
      state.loadCompanyBillingAddress = false;
    },
    updateUser(state, action) {
      state.updatingUser = true;
    },
    updateUserSuccess(state, action) {
      state.updatingUser = false;
    },
    updateUserFailure(state, action) {
      state.updatingUser = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = userEditSlice;
